// External Dependencies
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Internal Dependencies
import Footer from './components/Footer';
import Home from './pages/Home';
import ContactSuccess from './pages/ContactSuccess';
import MailflowBackups, { MailflowPrivacy } from './pages/MailflowBackups';

// Component Definition
const App: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route component={MailflowBackups} exact path="/mailflow-backups" />
        <Route component={MailflowPrivacy} exact path="/mailflow-backups/privacy" />
        <Route
          component={Home}
          exact
          path="/"
        />
        <Route
          component={ContactSuccess}
          exact
          path="/contact"
        />
      </Switch>

      <Footer />
    </Router>
  );
}

export default App;
